
// SVG Icon: more-items
export default { id: "terriajs-more-items" };
export const id = "terriajs-more-items";
export const name = "more-items";
